import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UNSUBSCRIBE_SMS } from '../../app.consts';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class UnsubscribeApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  unsubscribeSms(phoneNumber: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}${UNSUBSCRIBE_SMS}/${phoneNumber}`,
      {}
    );
  }
}
